import axios from "../../../../../services/api";
import Axios, {AxiosResponse, CancelTokenSource} from "axios";
import {getEnv} from "../../../../../api";
import {PaginationParamProps} from "../../../../hooks";
import {ProjetoAcaoInterface} from "../../../../interfaces";
import {removeEmptyProperties} from "../../../../utils/utils";

export interface IService {
    findAll: (
        params: PaginationParamProps,
        body: Record<string, any>,
        source?: {
            token: CancelTokenSource
        }
    ) => Promise<any>;

    getOptions: (consulta: boolean) => Promise<any>;
    findPratif: (idPratif: any) => Promise<any>;
    findRegionaisById: (idAcao: any) => Promise<any>;
    getFilterOptions: () => Promise<any>;
    create: (body: ProjetoAcaoInterface) => Promise<any>;
    editRegionais: (body: any) => Promise<any>;
    read: (id: string | number) => Promise<any>;
    update: (body: ProjetoAcaoInterface) => Promise<any>;
    getPendants: (body?: ProjetoAcaoInterface) => Promise<any>;
    findAcoesByUF: (siglaUf: any) => Promise<any>;
    delete: (id: any, inativo: any) => Promise<any>;
    updateStatus: ({id}: {
        id: any;
    }) => Promise<any>;
}

export const ProjetoAcaoService: IService = {

    findAll: async (params, body = {}) => {
        try {
            // @ts-ignore
            const response: AxiosResponse = await axios.post(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/consultar`,
                removeEmptyProperties(body),
                {
                    params,
                }
            );
            return response.data;
        } catch (error: any) {
            if (Axios.isCancel(error)) {
                console.log("Requisição cancelada", error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    getOptions: async (consulta = false) => {
        try {
            // @ts-ignore
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/opcoes?cadastro=${consulta}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    findPratif: async (idPratif) => {
        try {
            // @ts-ignore
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/pratif/${idPratif}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    findRegionaisById: async (idAcao) => {
        try {
            // @ts-ignore
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/regional/${idAcao}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    create: async (body) => {
        try {
            // @ts-ignore
            const response = await axios.post(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos`,
                body
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    read: async (id) => {
        try {
            if (!id) return;

            // @ts-ignore
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/${id}/`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    update: async (body) => {
        try {
            // @ts-ignore
            const response = await axios.put(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos`,
                body
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async (id: any, inativo = true) => {
        try {
            // @ts-ignore
            return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/alterar-status-aprovacao?idProjeto=${id}&statusAprovacao=REPROVADO`);
        } catch (error) {
            throw error;
        }
    },

    updateStatus: async ({id}) => {
        try {
            // @ts-ignore
            return await axios.put(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/${id}`
            );
        } catch (error) {
            throw error;
        }
    },

    getPendants: async (body: any) => {
        try {
            // @ts-ignore
            const response = await axios.post(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/sas/projetos/buscar-inativos`,
                body
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    findAcoesByUF: async (siglaUf: any) => {
        try {
            // @ts-ignore
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/acoes/${siglaUf}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getFilterOptions: async () => {
        try {
            // @ts-ignore
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/opcoes`
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },
    editRegionais: async (body) => {
        // @ts-ignore
        const response = await axios.put(
            `${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/regional`,
            body
        );
        return response.data;
    },

};
